import {Observable} from 'rxjs';

/**
 * Abstract permission provider that defines the contract for permission checking.
 * Implementations must provide methods to check permissions and notify when permissions are loaded.
 */
export abstract class PermissionProvider {
  /**
   * Check if the user has a specific permission
   * @param permission - The permission to check
   * @returns true if the user has the permission, false otherwise
   */
  abstract hasPermission(permission: string): boolean;

  /**
   * Check if permissions have been loaded
   * @returns true if permissions are available, false otherwise
   */
  abstract get hasPermissions(): boolean;

  /**
   * Observable that emits when permissions are loaded
   * @returns Observable that emits when permissions become available
   */
  abstract get permissionsLoaded$(): Observable<void>;
}
